import React from 'react';
import { useTranslation } from 'react-i18next';
import DataRoomMembersAccessField from 'components/DataRoomMembersAccessField';

import './StepGrantAccess.styles.scss';

const StepGrantAccess: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <p className="step-grant-access__description">
        {t('grantAccessStepDescription')}
      </p>
      <DataRoomMembersAccessField name="grantAccessDataRoomMemberIds" />
    </>
  );
};

export default StepGrantAccess;
